import React from 'react';
import { useViewChangeTracker } from '../../../hooks/useViewChangeTracker';
import { GenesGtpHeatmap } from './GenesGtpHeatmap';
import { GenesGtpSingleProfile } from './GenesGtpSingleProfile';

type GenesGraphsProps = {
  source: string;
  view: string;
  names: Array<{ id: string; name?: string; label?: string }>;
};

function GenesGraphs({ source, view, names }: GenesGraphsProps) {
  useViewChangeTracker('GenesGraphs', view, 'graph');

  if (names.length < 2) {
    return <GenesGtpSingleProfile source={source} view={view} names={names} />;
  }

  return <GenesGtpHeatmap source={source} view={view} names={names} />;
}

export default React.memo(GenesGraphs);
